module.exports = __webpack_public_path__ + "static/img/sbwtczl.b01480d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/sbwtczl.svg
// module id = Iv8/
// module chunks = 0